const labels = {
  All: { 'See the offering': 'See the offering' },
  FacilityDetails: { 'Ref: Page title': 'Ref: Page title', 'Ref: Review': 'Ref: Review' },
  FacilitiesList: { 'Ref: Page title': 'Ref: Page title', 'Ref: See details': 'Ref: See details' },
};
export default labels;
